import { Box, Typography, useMediaQuery } from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";
import { LazyLoadImage } from "react-lazy-load-image-component";

import FooterImage from "../../assets/images/FooterImage 2.png";
import FooterMobileImage from "../../assets/images/FooterMobileImage 2.png";
import Footerlogo from "../../assets/icons/Logo.png";
import LocationIcon from "../../assets/icons/LocationIcon.png";
import MessageIcon from "../../assets/icons/MessageIcon.png";
import CallIcon from "../../assets/icons/CallIcon.png";
import LinkedIn from "../../assets/images/linkedin.png";

const Footer = () => {
  const isMobile = useMediaQuery("(max-width:600px)");

  return (
    <Box
      sx={{
        width: "100%",
        position: "relative",
        backgroundColor: "#ecebeb",
        pt: { xs: "1rem", sm: "4rem" },
      }}
    >
      <LazyLoadImage
        src={isMobile ? FooterMobileImage : FooterImage}
        effect="blur"
        width="100%"
        height="100%"
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          objectFit: "cover",
          zIndex: 0,
        }}
      />
      <Box
        sx={{
          position: "relative",
          zIndex: 1,
          paddingLeft: { xs: "1rem", sm: "1rem", md: "6rem" },
          paddingRight: { xs: "1rem", sm: "6rem", md: "6rem" },
          paddingTop: { xs: "2.5rem", sm: "8rem" },
          paddingBottom: { xs: "2rem", sm: "1rem" },
        }}
      >
        {/* Main Container: Two Columns */}
        <Box
          sx={{
            display: "flex",
            flexDirection: isMobile ? "column" : "row",
            justifyContent: "space-between",
            alignItems: isMobile ? "center" : "flex-start",
            gap: "2rem",
            mb: "2rem",
          }}
        >
          {/* Left Column: Logo and Paragraph (40%) */}
          <Box
            sx={{
              width: isMobile ? "100%" : "30%",
              textAlign: "left",
              display: "flex",
              justifyContent: "justify-between",
              gap: "2rem",
            }}
          >
            <Box>
              <Box>
                <img
                  src={Footerlogo}
                  alt="Footer Logo"
                  style={{ width: isMobile ? "7rem" : "9rem" }}
                />
              </Box>
              {/* <Typography
                sx={{
                  fontFamily: 'Plus Jakarta Sans',
                  color: 'white',
                  fontSize: '0.9rem',
                  mt: '0.5rem'
                }}
              >
                Bringing clarity to a complex world
              </Typography> */}
            </Box>
            {/* <Box sx={{ minWidth: '120px', display: { xs: 'block', sm: 'none' } }}>
              <Typography
                sx={{
                  fontSize: '1.2rem',
                  fontWeight: 600,
                  color: 'white',
                  fontFamily: 'Plus Jakarta Sans',
                  mb: '1.2rem',
                }}
              >
                Support
              </Typography>
              <Typography
                sx={{
                  fontSize: '0.9rem',
                  fontWeight: 400,
                  color: 'white',
                  fontFamily: 'Plus Jakarta Sans',
                  mb: '0.2rem',
                }}
              >
                FAQ
              </Typography>
              <Typography
                sx={{
                  fontSize: '0.9rem',
                  fontWeight: 400,
                  color: 'white',
                  fontFamily: 'Plus Jakarta Sans',
                  mb: '0.2rem',
                }}
              >
                Terms & Conditions
              </Typography>
              <Typography
                sx={{
                  fontSize: '0.9rem',
                  fontWeight: 400,
                  color: 'white',
                  fontFamily: 'Plus Jakarta Sans',
                }}
              >
                Privacy Policy
              </Typography>
            </Box> */}
          </Box>

          {/* Right Column: All Links (60%) */}
          <Box
            sx={{
              width: isMobile ? "100%" : "40%",
              display: "flex",
              justifyContent: "space-between",
              gap: "2rem",
            }}
          >
            {/* Navigation Column */}
            <Box sx={{ minWidth: "120px" }}>
              <Typography
                sx={{
                  fontSize: "1.2rem",
                  fontWeight: 600,
                  color: "white",
                  fontFamily: "Plus Jakarta Sans",
                  mb: "1.2rem",
                }}
              >
                Navigation
              </Typography>
              <Typography
                sx={{
                  fontSize: "0.9rem",
                  fontWeight: 400,
                  color: "white",
                  fontFamily: "Plus Jakarta Sans",
                  mb: "0.2rem",
                }}
              >
                <Link
                  style={{ textDecoration: "none", color: "white" }}
                  to="/aboutus"
                >
                  About Us
                </Link>
              </Typography>
              <Typography
                sx={{
                  fontSize: "0.9rem",
                  fontWeight: 400,
                  color: "white",
                  fontFamily: "Plus Jakarta Sans",
                  mb: "0.2rem",
                }}
              >
                <Link
                  style={{ textDecoration: "none", color: "white" }}
                  to="/solutions"
                >
                  Solutions
                </Link>
              </Typography>
              <Typography
                sx={{
                  fontSize: "0.9rem",
                  fontWeight: 400,
                  color: "white",
                  fontFamily: "Plus Jakarta Sans",
                  mb: "0.2rem",
                }}
              >
                <Link
                  style={{ textDecoration: "none", color: "white" }}
                  to="/casestudies"
                >
                  Case Studies
                </Link>
              </Typography>
              <Typography
                sx={{
                  fontSize: "0.9rem",
                  fontWeight: 400,
                  color: "white",
                  fontFamily: "Plus Jakarta Sans",
                }}
              >
                <Link
                  style={{ textDecoration: "none", color: "white" }}
                  to="/contactus"
                >
                  Contact Us
                </Link>
              </Typography>
            </Box>

            {/* Contact Column */}
            <Box sx={{ minWidth: "120px" }}>
              <Typography
                sx={{
                  fontSize: "1.2rem",
                  fontWeight: 600,
                  color: "white",
                  fontFamily: "Plus Jakarta Sans",
                  mb: "1.2rem",
                }}
              >
                Contact Us
              </Typography>
              <Typography
                sx={{
                  display: "flex",
                  alignItems: "center",
                  fontSize: "0.9rem",
                  fontWeight: 400,
                  color: "white",
                  fontFamily: "Plus Jakarta Sans",
                  mb: "0.2rem",
                }}
              >
                <img
                  src={CallIcon}
                  alt="Call Icon"
                  style={{
                    width: "0.8rem",
                    height: "1rem",
                    marginRight: "0.5rem",
                  }}
                />
                +91 91360 10354
              </Typography>
              <Typography
                sx={{
                  display: "flex",
                  alignItems: "center",
                  fontSize: "0.9rem",
                  fontWeight: 400,
                  color: "white",
                  fontFamily: "Plus Jakarta Sans",
                  mb: "0.2rem",
                }}
              >
                <img
                  src={MessageIcon}
                  alt="Email Icon"
                  style={{
                    width: "1rem",
                    height: "1rem",
                    marginRight: "0.5rem",
                  }}
                />
                info@inteliphyle.com
              </Typography>
              <Typography
                sx={{
                  display: "flex",
                  alignItems: "center",
                  fontSize: "0.9rem",
                  fontWeight: 400,
                  color: "white",
                  fontFamily: "Plus Jakarta Sans",
                }}
              >
                <img
                  src={LocationIcon}
                  alt="Location Icon"
                  style={{
                    width: "0.8rem",
                    height: "1rem",
                    marginRight: "0.5rem",
                  }}
                />
                Mumbai, India
              </Typography>
              <Typography
                sx={{
                  display: "flex",
                  alignItems: "center",
                  fontSize: "0.9rem",
                  fontWeight: 400,
                  color: "white",
                  fontFamily: "Plus Jakarta Sans",
                  paddingTop: "0.2rem",
                }}
              >
                <img
                  src={LinkedIn}
                  alt="LinkedIn Icon"
                  style={{
                    width: "1rem",
                    height: "1rem",
                    marginRight: "0.5rem",
                  }}
                />
                <Link
                  style={{ textDecoration: "none", color: "white" }}
                  to="https://www.linkedin.com/company/inteliphyle/"
                >
                  LinkedIn
                </Link>
              </Typography>
            </Box>

            {/* Support Column */}
            {/* <Box sx={{ minWidth: '120px', display: { xs: 'none', sm: 'block' } }}>
              <Typography
                sx={{
                  fontSize: '1.2rem',
                  fontWeight: 600,
                  color: 'white',
                  fontFamily: 'Plus Jakarta Sans',
                  mb: '1.2rem',
                }}
              >
                Support
              </Typography>
              <Typography
                sx={{
                  fontSize: '0.9rem',
                  fontWeight: 400,
                  color: 'white',
                  fontFamily: 'Plus Jakarta Sans',
                  mb: '0.2rem',
                }}
              >
                FAQ
              </Typography>
              <Typography
                sx={{
                  fontSize: '0.9rem',
                  fontWeight: 400,
                  color: 'white',
                  fontFamily: 'Plus Jakarta Sans',
                  mb: '0.2rem',
                }}
              >
                Terms & Conditions
              </Typography>
              <Typography
                sx={{
                  fontSize: '0.9rem',
                  fontWeight: 400,
                  color: 'white',
                  fontFamily: 'Plus Jakarta Sans',
                }}
              >
                Privacy Policy
              </Typography>
            </Box> */}
          </Box>
        </Box>

        {/* Copyright + Privacy Policy */}
        <Box
          sx={{
            display: "flex",
            flexDirection: isMobile ? "column" : "row",
            alignItems: "center",
            justifyContent: "center",
            gap: isMobile ? "0.5rem" : "1.5rem",
            mt: "0.5rem",
          }}
        >
          <Typography
            sx={{
              textAlign: "center",
              color: "white",
              fontFamily: "Plus Jakarta Sans",
              fontSize: "0.8rem",
            }}
          >
            © 2024 Inteliphyle
          </Typography>
          <Typography
            sx={{
              textAlign: "center",
              color: "white",
              fontFamily: "Plus Jakarta Sans",
              fontSize: "0.8rem",
            }}
          >
            <Link
              to="/privacypolicy"
              style={{ color: "white", textDecoration: "none" }}
            >
              Privacy Policy
            </Link>
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default Footer;
